import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {RouteService} from './route.service';
import {Stop} from '../models/stop.model';
import {Route, RouteCreate} from '../models/route.model';
import {tap} from 'rxjs/operators';
import {Ticket, TicketCreate, TicketUpdate} from '../models/ticket.model';
import {BookingService} from './booking.service';
import {Passenger, PassengerCreate, PassengerUpdate} from '../models/passenger.model';
import {Reservation, ReservationCreate, ReservationUpdate} from '../models/reservation.model';
import {Comment, CommentCreate, CommentUpdate} from '../models/comment.model';
import {Flight, FlightCreate, FlightUpdate} from '../models/flight.model';
import {Payment, PaymentCreate} from '../models/payment.model';
import {VehicleCreate, Vehicle, VehicleUpdate} from '../models/vehicle.model';
import {RouteGroupCreate, RouteGroup} from '../models/routeGroup.model';
import {DispatchCreate, Dispatch} from '../models/dispatch.model';
import {DispatchGroup, DispatchGroupCreate} from '../models/dispatchGroup.model';
import {SearchService} from './search.service';
import {User, UserCreate} from '../models/user.model';
import {Setting} from '../models/setting.model';
import {Page, PageCreate} from '../models/page.model';
import {UploadCreate, Upload} from '../models/upload.model';
import {BlockedDate} from '../models/blockedDate.model';
import {Subject} from 'rxjs';
import {UserService} from './user.service';
import {Log, LogCreate} from '../models/log.model';
import {Discount, DiscountCreate, DiscountUpdate} from '../models/discount.model';
import {EditingService} from './editing.service';
import {DiscountService} from './discount.service';
import {AuthenticationService} from '../../authentication/authentication.service';

@Injectable({providedIn: 'root'})
export class DataStorageService {

    error = new Subject<string>();

    constructor(
        private http: HttpClient,
        private routeService: RouteService,
        private bookingService: BookingService,
        private editingService: EditingService,
        private discountService: DiscountService,
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private searchService: SearchService) {
    }
    private routeGroupQuery(routeGroups?: number[]): string {
        return routeGroups && routeGroups.length > 0
            ? '&routeGroup=' + routeGroups.join(',')
            : '';
    }
    createStop(newStop: Stop) {
        this.http.post('https://server.ozshuttle.com/api/stop/create.php', newStop)
            .subscribe(response => {
                if (response['error']) {
                    console.log('creating stop error');
                } else {
                    alert('stop created');
                    location.reload();
                }
            });
    }

    updateStop(id: number, newStop: Stop) {
        newStop.id = id;
        this.http.put('https://server.ozshuttle.com/api/stop/update.php', newStop)
            .subscribe(response => {
                if (response['error']) {
                    console.log('updating stop error');
                } else {
                    alert('stop updated');
                    location.reload();
                }
            });
    }

    deleteStop(id: number) {
        const params = {id: id};
        this.http.post('https://server.ozshuttle.com/api/stop/delete.php', params)
            .subscribe(response => {
                if (response['error']) {
                    console.log('deleting stop error');
                } else {
                    alert('stop deleted');
                    location.reload();
                }
            });
    }

    createRoute(route: RouteCreate) {
        this.http.post('https://server.ozshuttle.com/api/route/create.php', route)
            .subscribe(response => {
                if (response['error']) {
                    console.log('creating route error');
                } else {
                    alert('route created');
                    this.fetchRoutes();
                    // location.reload();
                }
            });
    }

    fetchRoutes() {
        return this.http.get<Route[]>('https://server.ozshuttle.com/api/route/read.php')
            .pipe(
                tap(routes => {
                    this.routeService.setRoute(routes);
                })
            );
    }

    updateRoute(newRoute: Route) {
        return this.http.put('https://server.ozshuttle.com/api/route/update.php', newRoute);
    }

    createRouteGroup(routeGroup: RouteGroupCreate) {
        this.http.post('https://server.ozshuttle.com/api/route_group/create.php', routeGroup)
            .subscribe(response => {
                if (response['error']) {
                    console.log('updating route create error');
                } else {
                    alert('route group created');
                    location.reload();
                }
            });
    }

    fetchRouteGroups() {
        return this.http.get<RouteGroup[]>('https://server.ozshuttle.com/api/route_group/read.php')
            .pipe(
                tap(routeGroups => {
                    this.routeService.setRouteGroup(routeGroups);
                })
            );
    }

    updateRouteGroup(newRouteGroup: RouteGroup) {
        this.http.put('https://server.ozshuttle.com/api/route_group/update.php', newRouteGroup)
            .subscribe(response => {
                if (response['error']) {
                    console.log('updating route group error');
                } else {
                    alert('route group updated');
                    location.reload();
                }
            });
    }

    createVehicle(vehicle: VehicleCreate) {
        return this.http.post('https://server.ozshuttle.com/api/vehicle/create.php', vehicle);
    }

    updateVehicle(vehicle: VehicleUpdate) {
        return this.http.put('https://server.ozshuttle.com/api/vehicle/update.php', vehicle);
    }

    fetchVehicles() {
        return this.http.get<Vehicle[]>('https://server.ozshuttle.com/api/vehicle/read.php')
            .pipe(
                tap(
                    vehicles => {
                        this.routeService.setVehicles(vehicles);
                    }
                )
            );
    }

    createDispatchGroup(dispatchGroup: DispatchGroupCreate) {
        this.http.post('https://server.ozshuttle.com/api/dispatch_group/create.php', dispatchGroup)
            .subscribe(response => {
                if (response['error']) {
                    console.log('creating route group error');
                } else {
                    alert('route group created');
                    location.reload();
                }
            });
    }

    fetchDispatchGroups() {
        return this.http.get<DispatchGroup[]>('https://server.ozshuttle.com/api/dispatch_group/read.php')
            .pipe(
                tap(dispatchGroups => {
                    this.routeService.setDispatchGroup(dispatchGroups);
                })
            );
    }

    updateDispatchGroup(newDispatchGroup: DispatchGroup) {
        this.http.put('https://server.ozshuttle.com/api/dispatch_group/update.php', newDispatchGroup)
            .subscribe(response => {
                if (response['error']) {
                    console.log('updating dispatch group error');
                } else {
                    alert('dispatch group updated');
                    location.reload();
                }
            });
    }

    createDispatch(dispatch: DispatchCreate) {
        return this.http.post('https://server.ozshuttle.com/api/dispatch/create.php', dispatch);
    }

    createDispatchMonth(dispatch: DispatchCreate) {
        return this.http.post('https://server.ozshuttle.com/api/dispatch/create_month.php', dispatch);
    }

    fetchDispatchesDate(date: string) {
        const params = new HttpParams({fromString: 'date=' + date});
        return this.http.get<Dispatch[]>('https://server.ozshuttle.com/api/dispatch/read_group_date.php', {params});
    }


    fetchDispatchesMonth(month: string) {
        const params = new HttpParams({fromString: 'month=' + month});
        return this.http.get<Dispatch[]>('https://server.ozshuttle.com/api/dispatch/read_group_month.php', {params});
    }

    deleteDispatch(id: number) {
        const params = {id: id};
        return this.http.post('https://server.ozshuttle.com/api/dispatch/delete.php', params);
    }

    fetchStops() {
        return this.http.get<Stop[]>('https://server.ozshuttle.com/api/stop/read.php')
            .pipe(
                tap(stops => {
                    this.routeService.setStop(stops);
                })
            );
    }

    fetchDiscount() {
        return this.http.get<Discount[]>('https://server.ozshuttle.com/api/discount/read.php')
            .pipe(
                tap(discounts => {
                    // this.bookingService.setDiscount(discounts);
                    // this.editingService.setDiscount(discounts);
                    this.discountService.setDiscount(discounts);
                })
            );
    }

    createDiscount(discount: DiscountCreate) {
        return this.http.post('https://server.ozshuttle.com/api/discount/create.php', discount);
    }

    updateDiscount(discount: DiscountUpdate) {
        return this.http.put('https://server.ozshuttle.com/api/discount/update.php', discount);
    }

    deleteDiscount(id: number) {
        const params = {id: id};
        return this.http.post('https://server.ozshuttle.com/api/discount/delete.php', params);
    }

    createReservation(reservation: ReservationCreate) {
        return this.http.post<Reservation>('https://server.ozshuttle.com/api/reservation/create.php', reservation)
            .pipe(
                tap(
                    responseData => {
                        if (responseData.id) {
                        } else {
                            this.error.next(responseData['error']);
                        }
                    }
                )
            );
    }

    createPassenger(passenger: PassengerCreate) {
        return this.http.post<Passenger>('https://server.ozshuttle.com/api/passenger/create.php', passenger);
    }

    createPassengers(passengers: PassengerCreate[]) {
        return this.http.post<any>('https://server.ozshuttle.com/api/passenger/create_group.php', passengers);
    }

    createCommentEditUser(comment: CommentCreate) {
        return this.http.post<Comment>('https://server.ozshuttle.com/api/comment/create_edit_user.php', comment)
            .pipe(
                tap(
                    responseData => {
                        if (responseData.id) {

                        } else {
                            this.error.next(responseData['error']);
                        }
                    }
                )
            );
    }

    createCommentMonth(comment: CommentCreate) {
        return this.http.post<Comment>('https://server.ozshuttle.com/api/comment/create_month.php', comment)
            .pipe(
                tap(
                    responseData => {
                        if (responseData.id) {

                        } else {
                            this.error.next(responseData['error']);
                        }
                    }
                )
            );
    }

    createCommentDate(comment: CommentCreate) {
        return this.http.post<Comment>('https://server.ozshuttle.com/api/comment/create_date.php', comment)
            .pipe(
                tap(
                    responseData => {
                        if (responseData.id) {

                        } else {
                            this.error.next(responseData['error']);
                        }
                    }
                )
            );
    }

    createCommentDateRoute(comment: CommentCreate) {
        return this.http.post<Comment>('https://server.ozshuttle.com/api/comment/create_date_route.php', comment)
            .pipe(
                tap(
                    responseData => {
                        if (responseData.id) {

                        } else {
                            this.error.next(responseData['error']);
                        }
                    }
                )
            );
    }

    fetchCommentsEditUser(edit_user_id: number) {
        const params = new HttpParams({fromString: 'id=' + edit_user_id});
        return this.http.get<Comment[]>('https://server.ozshuttle.com/api/comment/read_group_edit_user_id.php', {params});
    }

    fetchOzCommentsMonth(month: string) {
        const params = new HttpParams({fromString: 'month=' + month});
        return this.http.get<Comment[]>('https://server.ozshuttle.com/api/comment/read_group_month.php', {params});
    }

    fetchKeCommentsMonth(month: string) {
        const params = new HttpParams({fromString: 'month=' + month});
        return this.http.get<Comment[]>('https://server.hanslimo.com/api/comment/read_group_month.php', {params});
    }

    fetchCommentsDate(date: string) {
        const params = new HttpParams({fromString: 'date=' + date});
        return this.http.get<Comment[]>('https://server.ozshuttle.com/api/comment/read_group_date.php', {params});
    }

    fetchOzCommentsDate(date: string) {
        const params = new HttpParams({fromString: 'date=' + date});
        return this.http.get<Comment[]>('https://server.ozshuttle.com/api/comment/read_group_date.php', {params});
    }

    fetchKeCommentsDate(date: string) {
        const params = new HttpParams({fromString: 'date=' + date});
        return this.http.get<Comment[]>('https://server.hanslimo.com/api/comment/read_group_date.php', {params});
    }


    fetchCommentsDateRoute(date: string, route_id: number) {
        const params = new HttpParams({fromString: 'date=' + date + '&route_id=' + route_id});
        return this.http.get<Comment[]>('https://server.ozshuttle.com/api/comment/read_group_date_route_id.php', {params});
    }

    updateComment(newComment: CommentUpdate) {
        this.http.put('https://server.ozshuttle.com/api/comment/update_single.php', newComment)
            .subscribe(response => {
                console.log(response);
            });
    }

    deleteComment(id: number) {
        const params = {id: id};
        return this.http.post('https://server.ozshuttle.com/api/comment/delete.php', params);
    }

    createFlight(flight: FlightCreate) {
        return this.http.post<Flight>('https://server.ozshuttle.com/api/flight/create.php', flight);
    }

    createTicket(ticket: TicketCreate) {
        return this.http.post<Ticket>('https://server.ozshuttle.com/api/ticket/create.php', ticket);
    }

    updateTickets(tickets: TicketUpdate[]) {
        return this.http.put('https://server.ozshuttle.com/api/ticket/update_group.php', tickets);
    }

    createPayment(payment: PaymentCreate) {
        return this.http.post<Payment>('https://server.ozshuttle.com/api/payment/create.php', payment);
    }

    deletePayment(id: number) {
        const params = new HttpParams({fromString: 'id=' + id});
        return this.http.get<any>('https://server.ozshuttle.com/api/payment/delete.php', {params});
    }

    fetchReservation(id: number) {
        const params = new HttpParams({fromString: 'id=' + id});
        return this.http.get<Reservation>('https://server.ozshuttle.com/api/reservation/read_single.php', {params})
            .pipe(
                tap(
                    responseData => {
                        if (responseData) {
                            responseData.ticket.route.pick_stop = this.routeService.getStopById(responseData.ticket.route.pick_stop_id);
                            responseData.ticket.route.drop_stop = this.routeService.getStopById(responseData.ticket.route.drop_stop_id);
                            if (responseData.ticket_re) {
                                responseData.ticket_re.route.pick_stop
                                    = this.routeService.getStopById(responseData.ticket_re.route.pick_stop_id);
                                responseData.ticket_re.route.drop_stop
                                    = this.routeService.getStopById(responseData.ticket_re.route.drop_stop_id);
                            }
                        }

                    }
                )
            );
    }

    fetchReservationListsByStatus(status: string) {
        const params = new HttpParams({fromString: 'status=' + status});
        return this.http.get<Reservation[]>('https://server.ozshuttle.com/api/reservation/read_group_status.php', {params});
    }

    fetchReservationListsByRoute(route_id: number, org_date: string, new_date: string) {
        const params = new HttpParams({fromString: 'route_id=' + route_id + '&org_date=' + org_date + '&new_date=' + new_date});
        return this.http.get<Reservation[]>('https://server.ozshuttle.com/api/reservation/read_group_by_route.php', {params})
            .pipe(
                tap(
                    reservations => {
                        if (reservations) {
                            for (const reservation of reservations) {
                                reservation.ticket.route.pick_stop = this.routeService.getStopById(reservation.ticket.route.pick_stop_id);
                                reservation.ticket.route.drop_stop = this.routeService.getStopById(reservation.ticket.route.drop_stop_id);
                                if (reservation.ticket_re) {
                                    reservation.ticket_re.route.pick_stop
                                        = this.routeService.getStopById(reservation.ticket_re.route.pick_stop_id);
                                    reservation.ticket_re.route.drop_stop
                                        = this.routeService.getStopById(reservation.ticket_re.route.drop_stop_id);
                                }
                            }
                        }

                    }
                )
            );
    }

    fetchPassengerListsByStatus(status: string) {
        const params = new HttpParams({fromString: 'status=' + status});
        return this.http.get<Passenger[]>('https://server.ozshuttle.com/api/passenger/read_group.php', {params});
    }

    fetchReservationListsByTicketStatus(r_status: string, t_status: string) {
        const params = new HttpParams({fromString: 'r_status=' + r_status + '&t_status=' + t_status});
        return this.http.get<Reservation[]>('https://server.ozshuttle.com/api/reservation/read_group_by_status_ticket_status.php', {params})
            .pipe(
                tap(
                    reservations => {
                        if (reservations) {
                            for (const reservation of reservations) {
                                reservation.ticket.route.pick_stop =
                                    this.routeService.getStopById(reservation.ticket.route.pick_stop_id);
                                reservation.ticket.route.drop_stop =
                                    this.routeService.getStopById(reservation.ticket.route.drop_stop_id);
                                if (reservation.ticket_re) {
                                    reservation.ticket_re.route.pick_stop
                                        = this.routeService.getStopById(reservation.ticket_re.route.pick_stop_id);
                                    reservation.ticket_re.route.drop_stop
                                        = this.routeService.getStopById(reservation.ticket_re.route.drop_stop_id);
                                }
                            }
                        }

                    }
                )
            );
    }

    fetchPassengerNumsBlockedOrPending() {
        return this.http.get<any[]>('https://server.ozshuttle.com/api/passenger/read_group_num_blocked_or_pending.php');
    }

    fetchPassengerDateLists(date: string, routeGroups?: number[]) {
        const params = new HttpParams({fromString: 'date=' + date + this.routeGroupQuery(routeGroups)});
        return this.http.get<Passenger[]>('https://server.ozshuttle.com/api/passenger/read_group_date.php', {params});
    }

    fetchPassengerDateListsAgency(date: string, user_id: number, routeGroups?: number[]) {
        const params = new HttpParams({fromString: 'date=' + date + '&user_id=' + user_id + this.routeGroupQuery(routeGroups)});
        return this.http.get<Passenger[]>('https://server.ozshuttle.com/api/passenger/read_group_date.php', {params});
    }

    fetchPassengerMonthCounts(date: string) {
        // ===== TEMP DEBUG =====
        console.log('[fetchPassengerMonthCounts] called with date=', date);
        console.trace();
        // ======================
        const params = new HttpParams({fromString: 'date=' + encodeURIComponent(date)});
        return this.http.get<any>(
            'https://server.ozshuttle.com/api/passenger/read_group_calendar_month_count.php',
            {params}
        );
    }
    fetchPassengerDateListsCarrier(date: string, routeGroups?: number[]) {
        const params = new HttpParams({fromString: 'date=' + date + this.routeGroupQuery(routeGroups)});
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.authenticationService.user.value.token
        });
        return this.http.get<Passenger[]>(
            'https://server.ozshuttle.com/api/passenger/read_group_date.php',
            {params, headers}
        );
    }

    fetchPassengerMonthCountsCarrier(date: string) {
        const params = new HttpParams({fromString: 'date=' + encodeURIComponent(date)});
        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.authenticationService.user.value.token
        });
        return this.http.get<any>(
            'https://server.ozshuttle.com/api/passenger/read_group_calendar_month_count.php',
            {params, headers}
        );
    }


    fetchPassengerMonthCountsAgency(date: string, user_id: number, level?: number) {
        // ===== TEMP DEBUG =====
        console.log('[fetchPassengerMonthCountsAgency] called with:', { date, user_id, level });
        console.trace();
        // ===== END DEBUG =====

        const parts: string[] = ['date=' + encodeURIComponent(date)];
        if (user_id !== null && user_id !== undefined && +user_id > 0) {
            parts.push('user_id=' + encodeURIComponent(String(user_id)));
        }
        if (level !== null && level !== undefined) {
            parts.push('_level=' + encodeURIComponent(String(level)));
        }
        const params = new HttpParams({fromString: parts.join('&')});
        return this.http.get<any>(
            'https://server.ozshuttle.com/api/passenger/read_group_calendar_month_count.php',
            {params}
        );
    }
/*
    fetchPassengerMonthCountsAgency(date: string, user_id: number) {
        const params = new HttpParams({fromString: 'date=' + date + '&user_id=' + user_id});
        return this.http.get<any>('https://server.ozshuttle.com/api/passenger/read_group_calendar_month_count.php', {params});
    }
*/

    /*    fetchPassengerMonthCounts(date: string) {
            const params = new HttpParams({fromString: 'date=' + date});
            return this.http.get<any>('https://server.ozshuttle.com/api/passenger/read_group_calendar_month_count.php', {params});
        }*/

    fetchKePassengerMonthCounts(date: string) {
        const params = new HttpParams({fromString: 'date=' + date});
        return this.http.get<any>('https://server.hanslimo.com/api/passenger/read_group_calendar_month_count.php', {params});
    }
    fetchPassengerMonthCalendarGroupLists(month: string, calendar_group_id: string) {
        const params = new HttpParams({fromString: 'month=' + month + '&calendar_group_id=' + calendar_group_id});
        return this.http.get<Passenger[]>(
            'https://server.ozshuttle.com/api/passenger/read_group_month_calendar_group_id.php', {params});
    }

    fetchTotalPassengerMonthCalendarGroupLists(month: string, calendar_group_id: string) {
        const params = new HttpParams({fromString: 'month=' + month + '&calendar_group_id=' + calendar_group_id});
        return this.http.get<Passenger[]>(
            'https://server.ozshuttle.com/api/passenger/read_total_group_month_calendar_group_id.php', {params});
    }

    fetchPassengerSearchList(filter: any) {
        const json = JSON.stringify(filter);
        return this.http.get<Passenger[]>
        ('https://server.ozshuttle.com/api/passenger/read_group_search_list_new.php' + '?filter=' + encodeURIComponent(json))
            .pipe(
                tap(passengers => {
                    if (passengers) {
                        this.searchService.setPassengerList(passengers);
                    }
                })
            );
    }

    fetchPassengerSearchChart(condition: any) {
        const json = JSON.stringify(condition);
        return this.http.get<any>
        ('https://server.ozshuttle.com/api/passenger/read_group_search_chart.php' + '?condition=' + encodeURIComponent(json))
            .pipe(
                tap(passengers => {
                    if (passengers) {
                        this.searchService.setPassengerChart(passengers);
                        this.searchService.setQuery(condition);
                    }
                })
            );
    }

    fetchPassengerSingle(id: number) {
        const params = new HttpParams({fromString: 'id=' + id});
        return this.http.get<Passenger>('https://server.ozshuttle.com/api/passenger/read_single.php', {params})
            .pipe(
                tap(passengers => {
                    console.log(passengers);
                })
            );
    }

    fetchTicketsSchedule(start_date: string, end_date: string, route_group_id: number) {
        const params = new HttpParams({
            fromString: 'start_date=' + start_date
                + '&end_date=' + end_date + '&route_group_id=' + route_group_id
        });
        return this.http.get<Ticket[]>('https://server.ozshuttle.com/api/ticket/read_bulk_by_date.php', {params})
            .pipe(
                tap(tickets => {
                })
            );
    }

    updateTicketsStatus(status: string, ticket_ids: number[]) {
        return this.http.put
        ('https://server.ozshuttle.com/api/ticket/update_group_status.php', {ids: ticket_ids, status: status});
    }

    updateTicketsRoute(ticket_ids: number[], route_id: number) {
        return this.http.put('https://server.ozshuttle.com/api/ticket/update_group_route_id.php', {
            ids: ticket_ids,
            route_id: route_id
        });
    }

    updateReservationStatus(status: string, reservation_id: number) {
        return this.http.put
        ('https://server.ozshuttle.com/api/reservation/update_status.php', {id: reservation_id, status: status});
    }

    updateReservationQr(qr: string, reservation_id: number) {
        return this.http.put
        ('https://server.ozshuttle.com/api/reservation/update_qr.php', {id: reservation_id, qr: qr});
    }

    updateReservation(reservation: ReservationUpdate) {
        return this.http.put
        ('https://server.ozshuttle.com/api/reservation/update_single.php', {reservation: reservation});
    }

    updateReservationComment(comment: string, reservation_id: number) {
        return this.http.put
        ('https://server.ozshuttle.com/api/reservation/update_comment.php', {id: reservation_id, comment: comment});
    }

    updateTicket(ticket: TicketUpdate) {
        return this.http.put
        ('https://server.ozshuttle.com/api/ticket/update_single.php', {ticket: ticket});
    }

    deleteTicket(ticket_id: number) {
        const params = {id: ticket_id};
        return this.http.post('https://server.ozshuttle.com/api/ticket/delete.php', params);
    }

    updatePassenger(passenger: PassengerUpdate) {
        return this.http.put
        ('https://server.ozshuttle.com/api/passenger/update_single.php', {passenger: passenger});
    }

    fetchFlightTicketNoCount(ticket_no: number) {
        const params = new HttpParams({fromString: 'ticket_no=' + ticket_no});
        return this.http.get<number>('https://server.ozshuttle.com/api/flight/read_ticket_no.php', {params});
    }

    updateFlight(flight: FlightUpdate) {
        return this.http.put
        ('https://server.ozshuttle.com/api/flight/update_single.php', {flight: flight});
    }

    deleteFlight(flight_id: number) {
        const params = {id: flight_id};
        return this.http.post('https://server.ozshuttle.com/api/flight/delete.php', params);
    }

    updateNewReservationPassenger(passenger: PassengerUpdate) {
        return this.http.put
        ('https://server.ozshuttle.com/api/passenger/update_new_reservation.php', {passenger: passenger});
    }

    updatePassengerReservationId(passenger_ids: number[], reservation_id: number) {
        return this.http.put
        ('https://server.ozshuttle.com/api/passenger/update_group_reservation_id.php',
            {ids: passenger_ids, reservation_id: reservation_id});
    }

    fetchUserLists() {
        return this.http.get<User[]>('https://server.ozshuttle.com/api/user/read_group.php')
            .pipe(
                tap(users => {
                    this.userService.setUser(users);
                })
            );
    }

    fetchUserByUsername(user_name: string) {
        const params = new HttpParams({fromString: 'user_name=' + user_name});
        return this.http.get<User>('https://server.ozshuttle.com/api/user/read_single_by_user_name.php', {params});
    }

    fetchUser(id: number) {
        const params = new HttpParams({fromString: 'id=' + id});
        return this.http.get<User>('https://server.ozshuttle.com/api/user/read_single.php', {params});
    }

    updateUser(user: User) {
        return this.http.put
        ('https://server.ozshuttle.com/api/user/update_single.php', user);
    }

    deleteUser(id: number) {
        const params = {id: id};
        return this.http.post('https://server.ozshuttle.com/api/user/delete.php', params);
    }

    fetchSetting() {
        return this.http.get<Setting>('https://server.ozshuttle.com/api/setting/read.php')
            .pipe(
                tap(settings => {
                })
            );
    }

    updateSetting(setting: Setting) {
        return this.http.put
        ('https://server.ozshuttle.com/api/setting/update.php', setting);
    }

    // ===== Blog =====
    fetchBlogList() {
        return this.http.get<any[]>('https://server.ozshuttle.com/api/blog/admin-list.php');
    }

    fetchBlogSingle(id: number) {
        const params = new HttpParams({fromString: 'id=' + id});
        return this.http.get<any>('https://server.ozshuttle.com/api/blog/admin-get.php', {params});
    }

    saveBlog(blog: any) {
        // insert if id is null/empty, update if id exists (server decides)
        return this.http.post('https://server.ozshuttle.com/api/blog/admin-save.php', blog);
    }

    deleteBlog(id: number) {
        const params = {id: id};
        return this.http.post('https://server.ozshuttle.com/api/blog/admin-delete.php', params);
    }

    createPage(page: PageCreate) {
        return this.http.post<PageCreate>('https://server.ozshuttle.com/api/page/create.php', page);
    }

    fetchPage() {
        return this.http.get<Page[]>('https://server.ozshuttle.com/api/page/read.php')
            .pipe(
                tap(pages => {
                })
            );
    }

    updatePage(page: Page) {
        return this.http.put
        ('https://server.ozshuttle.com/api/page/update.php', page);
    }

    deletePage(id: number) {
        const params = {id: id};
        return this.http.post('https://server.ozshuttle.com/api/page/delete.php', params);
    }

    fetchPagePics() {
        return this.http.get<Upload[]>('https://server.ozshuttle.com/api/upload/read_page.php')
            .pipe(
                tap(pages => {
                })
            );
    }

    createUpload(upload: UploadCreate) {
        return this.http.post<Upload>('https://server.ozshuttle.com/api/upload/create.php', upload);
    }

    deleteUpload(id: number, name: string) {
        const params = {id: id, name: name};
        return this.http.post('https://server.ozshuttle.com/api/upload/delete.php', params);
    }

    deleteUploadRow(id: number, name: string) {
        const params = {id: id, name: name};
        return this.http.post('https://server.ozshuttle.com/api/upload/delete_row.php', params);
    }

    createBlockedDate(blockedDate: BlockedDate) {
        return this.http.post<BlockedDate>('https://server.ozshuttle.com/api/blocked_date/create.php', blockedDate);
    }

    deleteBlockedDate(blockedDate: BlockedDate) {
        return this.http.post('https://server.ozshuttle.com/api/blocked_date/delete.php', blockedDate);
    }

    fetchBlockedDate() {
        return this.http.get<BlockedDate[]>('https://server.ozshuttle.com/api/blocked_date/read.php')
            .pipe(
                tap(blockedDates => {
                    this.routeService.setBlockedDates(blockedDates);
                })
            );
    }

    addBlockDateAfterCheck(date: string, dispatch_group_id: number, num: number) {
        const params = new HttpParams({fromString: 'date=' + date + '&dispatch_group_id=' + dispatch_group_id + '&num=' + num});
        return this.http.get<any>('https://server.ozshuttle.com/api/blocked_date/add_after_check.php', {params}).subscribe(
            responseData => {
                console.log(responseData);
                this.fetchBlockedDate();
            }
        );
    }

    fetchUserLog(user_id: number) {
        const params = new HttpParams({fromString: 'id=' + user_id});
        return this.http.get<Log[]>('https://server.ozshuttle.com/api/log/read_group_user_id.php', {params})
            .pipe(
                tap(logs => {
                })
            );
    }

    createLog(newLog: LogCreate) {
        return this.http.post('https://server.ozshuttle.com/api/log/create.php', newLog);
    }

    fetchLogReservation(reservation_id: number) {
        const params = new HttpParams({fromString: 'id=' + reservation_id});
        return this.http.get<Log[]>('https://server.ozshuttle.com/api/log/read_group_reservation_id.php', {params})
            .pipe(
                tap(logs => {
                })
            );
    }

    fetchLogBlockedDateMonth(month: string) {
        const params = new HttpParams({fromString: 'month=' + month});
        return this.http.get<Log[]>('https://server.ozshuttle.com/api/log/read_group_blocked_date_month.php', {params})
            .pipe(
                tap(logs => {
                })
            );
    }

}
